import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  search: '',
  start: '',
  end: '',
  feedbackType: 'all',
  version: 'legacy',
  page: 1,
  perPage: 20,
  items: [],
  total: 0,
  isLoading: false,
  error: null,
  isExporting: false,
  exportError: null,
}

const setSearchHandler = (state, { payload }) => {
  state.search = String(payload ?? '')
}

const setStartHandler = (state, { payload }) => {
  state.start = String(payload ?? '')
}

const setEndHandler = (state, { payload }) => {
  state.end = String(payload ?? '')
}

const setFeedbackTypeHandler = (state, { payload }) => {
  state.feedbackType = payload || initialState.feedbackType
}

const setVersionHandler = (state, { payload }) => {
  state.version = payload || initialState.version
}

const setPageHandler = (state, { payload }) => {
  state.page = payload || 1
}

const fetchRequestHandler = state => {
  state.isLoading = true
  state.error = null
}

const fetchSuccessHandler = (state, { payload }) => {
  state.isLoading = false
  state.items = payload?.items || []
  state.total = payload?.total || 0
  state.perPage = payload?.perPage || state.perPage
  state.page = payload?.page || state.page
  state.error = null
}

const fetchFailureHandler = (state, { payload }) => {
  state.isLoading = false
  state.items = []
  state.total = 0
  state.error = payload || 'Error'
}

const exportRequestHandler = state => {
  state.isExporting = true
  state.exportError = null
}

const exportSuccessHandler = state => {
  state.isExporting = false
  state.exportError = null
}

const exportFailureHandler = (state, { payload }) => {
  state.isExporting = false
  state.exportError = payload || 'Error'
}

const resetHandler = state => {
  Object.assign(state, initialState)
}

const slice = createSlice({
  name: 'feedbackTools',
  initialState,
  reducers: {
    setSearch: setSearchHandler,
    setStart: setStartHandler,
    setEnd: setEndHandler,
    setFeedbackType: setFeedbackTypeHandler,
    setVersion: setVersionHandler,
    setPage: setPageHandler,
    fetchRequest: fetchRequestHandler,
    fetchSuccess: fetchSuccessHandler,
    fetchFailure: fetchFailureHandler,
    exportRequest: exportRequestHandler,
    exportSuccess: exportSuccessHandler,
    exportFailure: exportFailureHandler,
    reset: resetHandler,
  },
})

export const {
  setSearch,
  setStart,
  setEnd,
  setFeedbackType,
  setVersion,
  setPage,
  fetchRequest,
  fetchSuccess,
  fetchFailure,
  exportRequest,
  exportSuccess,
  exportFailure,
  reset,
} = slice.actions

export default slice.reducer
